// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__37bt7","growingTrangle":"styles_growingTrangle__zxGCP","exactPosition":"styles_exactPosition__2rFWj"};